export const dateRange = (state) => state.dateRange
export const accountEntries = (state) => state.accountEntries
export const gateCampingReport = (state) => state.gateCampingReport
export const gateParkingReport = (state) => state.gateParkingReport
export const campgroundReport = (state) => state.campgroundReport
export const campsiteReport = (state) => state.campsiteReport
export const parkingReport = (state) => state.parkingReport
export const gatePassReport = (state) => state.gatePassReport
export const invoiceSourceReport = (state) => state.invoiceSourceReport
export const generatedReport = (state) => state.generatedReport
export const errorLog = (state) => state.errorLog
